/**
 *  Тип той или иной операции. Например, аунтификации, логаута и тд.
 *  @publicApi
 */
export enum DxOperationResultType {
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED'
}
